import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'kui-nav-title',
  templateUrl: './nav-title.component.html',
})
export class KuiNavTitleComponent {
  @HostBinding('class.nav-title') navTitle = true;
}
